import React, { useState, useEffect } from "react";
import "../styles/paginated.css";

function Pagenated({
  maxPage,
  total,
  onPick,
  size,
  onChangePageSize,
  pageNo = 1,
}) {
  const [staySigned, setStaySigned] = useState(false);

  const [pages, setPages] = useState([]);
  const [pos, setPos] = useState(1);
  const [maxEntry, setMaxEntry] = useState(0);

  useEffect(() => {
    var k = 0;
    var _pages = [];
    var page = pageNo;
    // let maxPage=8;
    while (k < total) {
      if (page <= maxPage) {
        _pages.push({ id: page, text: page, selected: false });
        page++;
        k = k + size; //size of each page
      } else {
        _pages.push(
          { id: 0, text: "Next", selected: false },
          { id: 100, text: "Previous", selected: false }
        );

        break;
      }
    }
    console.log(_pages);
    setPages(_pages);
    const maxEntries = Math.min(size * pos, total);
    setMaxEntry(maxEntries);
    setPos(pageNo);
  }, [maxPage, total, pageNo]);

  const onSelect = (f) => {
    if (f.id == 0) {
      //last next one
      return;
    }
    if (f.id == 100) {
      //last previous one
      return;
    }
    onPick(f);
    setPos(f.id);
  };
  const onChangeSize = (e) => {
    onChangePageSize(e.target.value);
  };

  const onPrevious = () => {
    if (pos > 1) {
      const npage = pos - 1;
      onPick({ id: npage, text: "next" });
      setPos(npage);
      console.log(npage);
      const maxEntries = Math.min(size * npage, total);
      setMaxEntry(maxEntries);
    }
  };

  const onNext = () => {
    const maxEntries = Math.min(size * pos, total);
    if (total >= maxEntries) {
      const npage = pos + 1;
      onPick({ id: npage, text: "next" });
      setPos(npage);
      console.log(npage);
      setMaxEntry(Math.min(size * npage, total));
    }
  };

  return (
    <div style={{ flex: 1, width: "100%" }}>
      <div className="pagenate-new">
        <div className="p-part-1">
          <span>Show</span>
          <div className="select-wrapper">
            <select value={size} onChange={onChangeSize}>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="30">30</option>
              <option value="40">40</option>
              <option value="50">50</option>
              <option value="60">60</option>
              <option value="70">70</option>
              <option value="80">80</option>
              <option value="90">90</option>
              <option value="100">100</option>
            </select>
            <div className="select-icon">
              <svg
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.4"
                  d="M15.5184 7L8.48251 7C6.93892 7 5.97718 8.67443 6.75495 10.0077L10.2729 16.0385C11.0446 17.3615 12.9562 17.3615 13.728 16.0385L17.2459 10.0077C18.0237 8.67443 17.0619 7 15.5184 7Z"
                  fill="#5CA9FB"
                />
              </svg>
            </div>
          </div>

          <span>Entries</span>
          <span>
            Showing {pos == 1 ? 1 : size * (pos - 1)} -{" "}
            {Math.min(size * pos, total)} of {total} entries
          </span>
        </div>
        <div className="p-part-2">
          {pos > 1 && (
            <div onClick={onPrevious}>
              <svg
                width={11}
                height={12}
                viewBox="0 0 11 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g opacity="0.4">
                  <path
                    d="M10.0307 9.03887V2.00301C10.0307 0.459432 8.35631 -0.502312 7.02299 0.275454L0.992259 3.79338C-0.330752 4.56514 -0.330754 6.47674 0.992257 7.2485L7.02299 10.7664C8.3563 11.5442 10.0307 10.5824 10.0307 9.03887Z"
                    fill="#171D1A"
                  />
                </g>
              </svg>
              <span>Previous</span>{" "}
            </div>
          )}
          {total > maxEntry && (
            <div onClick={onNext}>
              <span>Next</span>{" "}
              <svg
                width={11}
                height={12}
                viewBox="0 0 11 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.4"
                  d="M0 9.03887V2.00301C0 0.459432 1.67443 -0.502312 3.00774 0.275454L9.03847 3.79338C10.3615 4.56514 10.3615 6.47674 9.03847 7.2485L3.00774 10.7664C1.67443 11.5442 0 10.5824 0 9.03887Z"
                  fill="#171D1A"
                />
              </svg>
            </div>
          )}
        </div>

        {/* {pages.map((item, idx) =>{return (
        <div className={pos==item.id?'active':''} key={idx} value={item.id} onClick={()=>onSelect(item)}>{item.text}</div>
      )})} */}
      </div>
    </div>
  );
}

export default Pagenated;
